import * as React from 'react';
// @ts-ignore
import loadScript from 'load-script';
import classnames from 'classnames';

export interface SymbolProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  name: string;
  size?: number | number[];
}

const Symbol: React.FC<SymbolProps> = (props) => {
  const { name, className, ...rest } = props;

  return (
    <svg aria-hidden="true" className={classnames('icon', className)} {...rest}>
      <use xlinkHref={`#${name}`} />
    </svg>
  );
};

export default Symbol;
